import {
  SEARCH_EVENT_LOAD,
  SEARCH_EVENT_LOAD_SUCCESS,
  SEARCH_EVENT_LOAD_FAIL,
  FILTERED_PRODUCT,
  SEARCH_EVENT_BY_ID_LOAD,
  SEARCH_EVENT_BY_ID_LOAD_SUCCESS,
  SEARCH_EVENT_BY_ID_LOAD_FAIL,
  SEARCH_DATA,
  EVENT_DATE_RANGE,
  CLEAN_STATE_WARNING,
  ADD_ALL_EVENT_SEARCH_BY_USER_DETAILS,
  CLEAN_SEARCH_USER_DETAILS,
} from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  productSearchResult: {},
  filterProductSearchResult: {},
  extraData: [],
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SEARCH_EVENT_LOAD:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_DATA:
      return {
        ...state,
        filterProductSearchResult: {
          ...state.filterProductSearchResult,
          searchDataResult: action.payload,
        },
      };
    case SEARCH_EVENT_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        productSearchResult: action.result,
        filterProductSearchResult: action.result,
        currentPage: 1,
        productPerPageOfPagination: 30,
        error: null,
        extraData: action.result
          && Array.isArray(action.result.events)
          && [...state.extraData, ...action.result.events],
      };
    case SEARCH_EVENT_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        searchData: null,
        error: action.error,
        extraData: [],
      };
    case FILTERED_PRODUCT:
      return {
        ...state,
        searchData: {
          ...state.searchData,
          searchEventResult: action.data,
        },
      };
    case SEARCH_EVENT_BY_ID_LOAD:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_EVENT_BY_ID_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        guestData: action.result,
        error: null,
        extraData: [],
      };
    case SEARCH_EVENT_BY_ID_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        searchData: null,
        error: action.error,
        extraData: [],
      };
    case EVENT_DATE_RANGE:
      return {
        ...state,
        filterProductSearchResult: {
          filterProductSearchResult: Object.assign({}),
          eventDateEndRange: action.payload.eventDateEndRange,
          eventDateStartRange: action.payload.eventDateStartRange,
        },
      };
    case CLEAN_STATE_WARNING:
      return {
        ...state,
        filterProductSearchResult: {
          filterProductSearchResult: Object.assign({}),
        },
      };
    case ADD_ALL_EVENT_SEARCH_BY_USER_DETAILS:
      return {
        ...state,
        extraData: [...action.payload],
      };
    case CLEAN_SEARCH_USER_DETAILS:
      return {
        ...state,
        extraData: [],
         productSearchResult: {},
         filterProductSearchResult: {},
      };
    
    default:
      return state;
  }
}
